<!-- The toolbar strip stays, empty, until there is content -->
<div class="canvas-toolbar">
    @if (hasToolbarContent()) {
    <span class="canvas-title" data-automation-id="canvas-title">{{ title() ?? (titleKey() | translate) }}</span>
    }
</div>

<div class="canvas-content" [attr.data-state]="state()" [ngSwitch]="state()">
    <p-ai-chat-canvas-empty-state
        *ngSwitchCase="'thinking'"
        kind="info"
        [title]="generatingKey() | translate"
    ></p-ai-chat-canvas-empty-state>
    <p-ai-chat-canvas-empty-state
        *ngSwitchCase="'awaiting'"
        kind="info"
        [title]="'aichat.canvas.awaiting.title' | translate"
        [message]="frameStore.statusMessage()"
    ></p-ai-chat-canvas-empty-state>
    <p-ai-chat-canvas-empty-state
        *ngSwitchCase="'error'"
        kind="error"
        [title]="'aichat.canvas.error.title' | translate"
        [message]="frameStore.statusMessage() || ('aichat.canvas.error.unknown_display' | translate)"
    ></p-ai-chat-canvas-empty-state>
    <!-- 'content' and 'creating' both render the display; in 'creating' the display reads frameStore.status() and disables its checkboxes -->
    <ng-container *ngSwitchDefault>
        <ng-container *ngComponentOutlet="displayComponent(); inputs: displayInputs()"></ng-container>
    </ng-container>
</div>

<div class="canvas-footer" [attr.data-mode]="footerMode()">
    <span *ngIf="footerError() as error" class="canvas-footer-error" data-automation-id="canvas-footer-error">{{ error }}</span>
    <p-ai-chat-canvas-busy-pill *ngIf="footerMode() === 'busy'">
        {{ busyKey() | translate }}
    </p-ai-chat-canvas-busy-pill>
    <ng-container *ngIf="footerMode() === 'actions'">
        <p-button
            *ngFor="let action of frameStore.actions(); trackBy: trackAction"
            [label]="action.label_key | translate"
            [buttonType]="action.primary ? buttonType.Primary : buttonType.Secondary"
            [disabled]="!isActionEnabled(action.primary)"
            [matTooltip]="action.primary && primaryActionHintKey() ? (primaryActionHintKey() | translate) : ''"
            [attr.data-automation-id]="'canvas-action-' + action.id"
            (buttonClicked)="onAction(action)"
        ></p-button>
    </ng-container>
</div>
